import { cornType, makeCorn } from '@eigtech/shared-corn';
import { serviceName } from './service.js';
export const TemplateCornSchema = cornType(serviceName, 'template');
export const ensureTemplateCorn = (templateId) => isTemplateCorn(templateId) ? templateId : makeTemplateCorn(templateId);
export const isTemplateCorn = (bookId) => TemplateCornSchema.safeParse(bookId).success;
export const makeTemplateCorn = (resourceId) => makeCorn({ serviceName, resourceType: 'template', resourceId });
export const documentTemplateDocumentCorn = makeTemplateCorn('document');
